module.exports = __webpack_public_path__ + "static/media/ratings-table.9065d72d.png";